const endpoints = {
	addReactionToItem: '/interactions/addReactionToItem',
	markInteractionAsViewed: '/interactions/markInteractionAsViewed',
	getUserInteractions: '/interactions/getUserInteractions',
}
export {endpoints}